<a href="javascript:void(0);" class="node-anchor" [ngClass]="{'selected':fileExplorerService.selected==folder}">
  <i (click)="fileExplorerService.toggleExpand(folder)" class="fa fa-folder me-2" *ngIf="!folder.isOpen"></i>
  <i (click)="fileExplorerService.toggleExpand(folder)" class="fa fa-folder-open me-2" *ngIf="folder.isOpen"></i>
  <span (click)="fileExplorerService.setSelected(folder)">{{folder.name}}</span>
  <i class="fa fa-refresh loader-g" *ngIf="folder.isLoadingsubItems"></i>
</a>

<ng-container *ngIf="folder.isOpen">

  <ul *ngFor="let folder of folder.children | treeFolderFilter" class="tree">
    <li>
      <tree-node [folder]="folder"
                 (mouseenter)="fileExplorerService.setHoveredTreeItem(folder)"
                 (mouseleave)="fileExplorerService.clearHoveredTreeItem()"></tree-node>
    </li>
  </ul>
</ng-container>
